import { EditPropertyAdV2 } from '../PropertyAdEditor';
import { Dashboard } from './Dashboard';

export const EditPropertyAdV2Page = () => (
  <Dashboard openLogIn>
    <EditPropertyAdV2 />
  </Dashboard>
);
